import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as Flash from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'

const promotionFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.promotions.view.filter
const promotionDateSelector: any = (state: ApplicationState) => state.contentCalendar.data.selectedDate

export const epic = ReduxObservable.combineEpics(
  Flash.createFlashSuccessEpic(Constants.ADD_PROMOTION, 'Promotion added'),
  Flash.createFlashSuccessEpic(Constants.EDIT_PROMOTION, 'Promotion updated'),
  IsActive.createFilterAddedEpic(Constants.ADD_PROMOTION, Actions.fetchPromotions, promotionFilterSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_PROMOTIONS, Actions.fetchPromotions, promotionFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_PROMOTIONS_URL, Actions.fetchPromotions, promotionFilterSelector),
  IsActive.createNavigateToPageEpic(Menu.CONTENT_CALENDAR_URL, Actions.fetchPromotionsByDate, promotionDateSelector),
  IsActive.createDateChangeEpic(IsActive.UPDATE_SELECTED_DATE, Actions.fetchPromotionsByDate, promotionDateSelector),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_PROMOTION, Actions.statusUpdate),
)



// WEBPACK FOOTER //
// ./src/pages/promotions/epic.ts